import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Scale, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CURRENT_TERMS_VERSION = "2026-07";

export const TermsBanner = () => {
  const { user, refreshUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || dismissed || user.terms_accepted_version === CURRENT_TERMS_VERSION) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/accept-terms");
      await refreshUser?.();
      setDismissed(true);
    } catch { setDismissed(true); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-[#0A0A0A] text-white" data-testid="terms-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex flex-wrap items-center gap-3 text-sm">
        <Scale className="w-4 h-4 text-[#0047AB] shrink-0" />
        <span>We've updated our <Link to="/terms" className="underline hover:text-[#7EB1FF]">Terms of Service</Link> and <Link to="/privacy" className="underline hover:text-[#7EB1FF]">Privacy Policy</Link>.</span>
        <div className="ml-auto flex items-center gap-3">
          <button onClick={accept} disabled={busy} className="bg-white text-[#0A0A0A] px-4 py-1 text-xs font-medium hover:bg-neutral-200 transition-colors disabled:opacity-60" data-testid="terms-accept-btn">{busy ? "Saving…" : "Review & accept"}</button>
          <button onClick={() => setDismissed(true)} className="text-neutral-400 hover:text-white" data-testid="terms-dismiss" aria-label="Dismiss"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
};
